import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import {
    Box,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Grid,
    Typography
} from "@mui/material/";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { strings } from "../../../../../common/i18n";
import styles from "../styles";

/**
 * Close Summary Excluded Component
 */
export default ({ value }) => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    const { typesList } = useSelector((state) => state);

    /** Exclusion reason for auditor and controller */
    const [count, data] = useMemo(() => {
        const exclusionData = {
            auditorExcluded: {
                count: 0,
                reason: {}
            },
            controllerExcluded: {
                count: 0,
                reason: {}
            }
        };

        const constructExclusionReason = (type, reason) => {
            const exclusionReason = reason
                .replace("Excluded: ", "")
                .split(",")[0];
            exclusionData[type].count += 1;
            exclusionData[type].reason[exclusionReason] ||= 0;
            exclusionData[type].reason[exclusionReason] += 1;
        };

        const excluded = value
            .filter((item) => item.controllerExcluded || item.auditorExcluded)
            .map((item) => {
                if (item.controllerExclusionReason.length > 1) {
                    constructExclusionReason(
                        "controllerExcluded",
                        item.controllerExclusionReason
                    );
                } else if (item.auditorExclusionReason.length > 1) {
                    constructExclusionReason(
                        "auditorExcluded",
                        item.auditorExclusionReason
                    );
                }
            });
        return [excluded.length, exclusionData];
    }, [typesList, value]);

    /** Grid  Item fo exclusion reason types */
    const gridItem = (type, exclusion) => {
        const { count, reason } = exclusion;
        return count > 0 ? (
            <>
                {Object.entries(reason).map(([label, value]) => (
                    <Box key={`${label}-${value}`} sx={styles.flexContainer}>
                        <Typography sx={styles.label} variant="body2">
                            {label}
                        </Typography>
                        <Typography sx={styles.count} variant="body2">
                            {value}
                        </Typography>
                    </Box>
                ))}
            </>
        ) : (
            ""
        );
    };

    return (
        Boolean(Object.keys(data).length) && (
            <Grid container>
                <Grid item xs={12}>
                    {data.auditorExcluded.count > 0 && (
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                aria-controls="panel1d-content"
                                id="panel1d-header"
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Box sx={styles.flexContainer}>
                                    <Typography variant="overline">
                                        {strings("auditorExcluded")}
                                    </Typography>
                                    <Typography
                                        variant="overline"
                                        color="primary"
                                    >
                                        {data.auditorExcluded.count}
                                    </Typography>
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                {gridItem("auditor", data.auditorExcluded)}
                            </AccordionDetails>
                        </Accordion>
                    )}
                    {data.controllerExcluded.count > 0 && (
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                aria-controls="panel2d-content"
                                id="panel2d-header"
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Box sx={styles.flexContainer}>
                                    <Typography variant="overline">
                                        {strings("controllerExcluded")}
                                    </Typography>
                                    <Typography
                                        variant="overline"
                                        color="primary"
                                    >
                                        {data.controllerExcluded.count}
                                    </Typography>
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                {gridItem(
                                    "controller",
                                    data.controllerExcluded
                                )}
                            </AccordionDetails>
                        </Accordion>
                    )}
                </Grid>
            </Grid>
        )
    );
};
